<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="appId：">{{ form.appId }}</el-form-item>

        <el-form-item label="IP白名单：">
          <el-input v-model="form.rcsIp" type="text" size="small" :disabled="false" style="width: 550px">
          </el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="resetIp">更新白名单</el-button>
        </el-form-item>

        <el-form-item label="md5(signKey)：">
          <el-input v-model="form.signKey" type="text" size="small" :disabled="true" style="width: 550px">
          </el-input>
        </el-form-item>

        <el-form-item size="large">
          <el-button @click="resetApi">重置signKey</el-button>
          <div class="tipsInfo" style="color: #f56c6c">
            平台不保存商户真实密钥,请重置后妥善保管(需要浏览器允许下载文件)
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      form: {
        appId: '',
        rcsIp: '',
        signKey: '',
      },
      pwdType: 'password',
    }
  },
  created() {
    this.axios.get('/merchant/getKey', { params: {} }).then(res => {
      if (res.code === 200) {
        this.form = res.data
        this.form.signKey =
          this.form.signKey.slice(0, 8) +
          '*******' +
          this.form.signKey.slice(
            this.form.signKey.length - 8,
            this.form.signKey.length
          )
        // console.log(this.form);
      }
    })
  },
  methods: {
    showPwd() {
      this.pwdType === 'password'
        ? (this.pwdType = '')
        : (this.pwdType = 'password')
    },
    resetApi() {
      this.$confirm('确认重置密钥吗? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$confirm('请确认该密钥没有在线上运行', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }).then(() => {


          this.axios
            .post('/merchant/resetKey', {
              params: this.form,
              responseType: 'blob',
            })
            .then(res => {
              let filename
              var contentDisposition = res.headers['content-disposition']
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              var matches = filenameRegex.exec(contentDisposition)
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '')
              }
              // console.log(filename)

              // const time = new Date().getTime();
              let blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel',
              })
              // 将blob对象转为一个URL
              var blobURL = window.URL.createObjectURL(blob)
              // 创建一个a标签
              var tempLink = document.createElement('a')
              // 隐藏a标签
              tempLink.style.display = 'none'
              // 设置a标签的href属性为blob对象转化的URL
              tempLink.href = blobURL
              // 给a标签添加下载属性
              tempLink.setAttribute('download', filename)
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
              }
              // 将a标签添加到body当中
              document.body.appendChild(tempLink)
              // 启动下载
              tempLink.click()
              // 下载完毕删除a标签
              document.body.removeChild(tempLink)
              window.URL.revokeObjectURL(blobURL)
              this.$message({
                message: '导出成功~',
                type: 'success',
              })
            })



        }).catch(() => { })
      }).catch(() => { })
    },

    resetIp() {
      let params = {
        ipString: this.form.rcsIp
      }
      this.$confirm('确认更新白名单IP吗? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.axios.get("/merchant/resetIp", { params }).then((res) => {
          this.$message({
            message: '更新成功~',
            type: 'success',
          })
        });
      }).catch(() => { })
    },
    copy(text) {
      let clipboard = new Clipboard('.copy_api', {
        text: () => {
          return text
        },
      })
      clipboard.on('success', e => {
        this.$message.success('复制成功！')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制,请手动复制！')
        clipboard.destroy()
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>